export default {
  SET_RECENTS: "SET_RECENTS",
  SET_VIEWED: "SET_VIEWED",
  SET_LIKED: "SET_LIKED",
  SET_RATED: "SET_RATED",
  SET_POST: "SET_POST",
};
